import React from 'react';
import styled from 'styled-components';
import sgpLogo from '../Assets/logo/CMC-Invest_stacked_black.svg';

const StyledImg = styled.img`
  height: 28px;
  width: auto;
`;

export const SgpLogo: React.FC<React.ImgHTMLAttributes<HTMLImageElement>> = (props) => <StyledImg src={sgpLogo} {...props} />;
